import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import ActiveProvider from 'components/Shared/ProductJourney/Context/ActiveContext';
import PreviewMapComponent from './PreviewMapComponent';
import useWindowSize from 'hooks/useWindowSize';
import { ContentTypeEnum } from 'types/types';
const BUTTON_WIDTH = 350;
const BUTTON_HEIGHT = 200;
const Container = styled.div `
  width: 100%;
  height: ${BUTTON_HEIGHT}px;
  font-family: Lato;

  * {
    box-sizing: border-box !important;
  }
`;
const PreviewItem = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: ${BUTTON_WIDTH}px;
  max-width: ${({ maxWidth }) => maxWidth}px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: opacity 0.125s ease;

  &:hover {
    opacity: 0.7;
  }

  &.loading {
    cursor: default;

    .shimmer:after {
      content: '';
    }
  }

  .shimmer {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow-x: hidden;
  }

  .shimmer::after {
    content: none;
    position: absolute;
    top: 0;
    right: -100%;
    bottom: 0;
    left: -100%;
    background: linear-gradient(
      90deg,
      rgba(240, 240, 240, 0.3) 33%,
      rgba(240, 240, 240, 0.9),
      rgba(240, 240, 240, 0.3) 66%
    );
    animation: shimmer 1s infinite linear;
  }

  @keyframes shimmer {
    from {
      transform: translateX(-33.3%);
    }
    to {
      transform: translateX(33.3%);
    }
  }
`;
const TextContainer = styled.div `
  position: absolute;
  top: 8px;
  flex: 1;
  justify-content: space-between;
  padding: 10px 16px 10px 10px;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.11);
  z-index: 1;
  background: #fff;
`;
const Headline = styled.h6 `
  font-size: 12px !important;
  font-weight: 700 !important;
  margin: 0 !important;
  text-transform: uppercase;
`;
const PreviewMap = ({ lang, onClick, className, supplyChain, latestBatch, productId, }) => {
    const { width: windowWidth } = useWindowSize();
    const { t } = useTranslation();
    return (React.createElement(Container, { id: "st-preview-button-container" },
        React.createElement(PreviewItem, { className: className, onClick: onClick, maxWidth: windowWidth, id: "st-preview-button" },
            React.createElement(ActiveProvider, { lang: lang, supplyChain: supplyChain, productId: productId, latestBatch: latestBatch, isIntegration: true },
                React.createElement(PreviewMapComponent, { width: BUTTON_WIDTH, height: BUTTON_HEIGHT })),
            React.createElement(TextContainer, null,
                React.createElement(Headline, null, t(`content-blocks.${ContentTypeEnum.PRODUCT_JOURNEY_BLOCK}`))),
            React.createElement("div", { className: "shimmer" }))));
};
export default PreviewMap;
